<form class="form-container" [formGroup]="form">
    <!-- <h2 mat-dialog-title>{{'ADD_COMPLAINT_SUBTYPE' | translate}}</h2> -->

    <mat-card class="grid-card">
        <mat-card-content>
            <div>
                <h2 mat-dialog-title>{{'REGISTER_NEW_COMPLAINT' | translate}}</h2>
                <div class="row">
                    <div class="col-12 p-0">
                        <h2 class="dragCardsHeading">{{'CITIZEN_DETAILS' | translate}}</h2>
                    </div>
                </div>
                <div class="row g-3 form-fields-container">
                    <div class="col-lg-4 col-md-6 mb-0 ps-0 form-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'NAME' | translate}} </mat-label>
                            <input matInput formControlName="complainantName" maxlength="30" size="small">
                            @if (f['complainantName'].errors) {
                            <mat-error style="margin-top: 10px;">
                                @if (f['complainantName'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['complainantName'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' |
                                    translate}}</span>}
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['complainantName'].value?.length || 0 }}/30</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0 ps-0 form-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'GENDER' | translate}}</mat-label>
                            <mat-select formControlName="gender">
                                <mat-option [value]="'Male'">Male</mat-option>
                                <mat-option [value]="'Female'">Female</mat-option>
                                <mat-option [value]="'Transgender Person'">Transgender Person</mat-option>
                            </mat-select>
                            @if(f['gender'].errors){
                            <mat-error>
                                @if(f['gender'].errors['required']){
                                <span>{{'GENDER_REQUIRED' | translate}}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0  ps-0 form-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'CNIC' | translate}} </mat-label>
                            <input matInput formControlName="cnic" (input)="formatCnic($event)" maxlength="15"
                                size="small">
                            @if (f['cnic'].errors) {
                            <mat-error style="margin-top: 5px;">
                                @if (f['cnic'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['cnic'].errors['pattern']) { <span>{{'CNIC_PATTERN' |
                                    translate}}</span>}
                                @if (f['cnic'].errors['minlength'] || f['cnic'].errors['maxlength']) {
                                <span>{{'MINLENGTH_13' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0 form-field-wrapper">
                        <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true" customPlaceholder="Phone" [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                            [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Pakistan" [maxLength]="15"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National" formControlName="cellPhoneNo"
                            class="custom-control custom-phone-input" [class]="getPhoneInputClass()"
                            (input)="sanitizeInput($event)">
                        </ngx-intl-tel-input>
                        @if (f['cellPhoneNo'].touched && f['cellPhoneNo'].errors) {
                        <div class="text-danger" style="margin-top: 10px;">
                            @if (f['cellPhoneNo'].errors['required']) { <span>{{'MOBILE_REQUIRED' | translate}}</span>}
                            @if (f['cellPhoneNo'].errors['maxLength']) { <span>{{'MAX_LENGTH_20' | translate}}</span>}
                            @if (f['cellPhoneNo'].errors['pattern']) { <span>{{'INVALID_MOBILE_PATTERN' |
                                translate}}</span>}
                        </div>
                        }
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0 ps-0 form-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'EMAIL' | translate}}</mat-label>
                            <input matInput formControlName="email" size="small" [maxLength]="60">
                            @if (f['email'].errors) {
                            <mat-error style="margin-top: 5px;">
                                @if (f['email'].errors['required']) {
                                <span>{{'FIELD_REQUIRED' | translate}}</span>
                                }
                                @if (f['email'].errors['pattern'] || f['email'].errors['email']) {
                                <span>{{'INVALID_EMAIL' | translate}}</span>
                                }
                                @if (f['email'].errors['maxlength']) {
                                <span>{{'MAX_LENGTH_60' | translate}}</span>
                                }
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['email'].value?.length || 0 }}/60</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0 ps-0 form-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'Passport no' | translate}} </mat-label>
                            <input matInput formControlName="passportNo" size="small">
                            @if (f['passportNo'].touched && f['passportNo'].errors && f['passportNo'].value?.length) {
                            <mat-error style="margin-top:5px">
                                @if (f['passportNo'].errors['maxlength'] || f['passportNo'].errors['minlength']) {
                                <span>{{'PASSPORT_MAX_LENGTH_9' | translate}}</span>
                                }
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-0">
                        <mat-form-field appearance="outline" class=" bold-border w-100" floatLabel="always">
                            <mat-label>{{'ADDRESS' | translate}}</mat-label>
                            <textarea matInput formControlName="address" rows="3" style="resize: none;"></textarea>
                            @if (f['address'].errors) {
                            <mat-error style="margin-top: 8px">
                                @if (f['address'].errors['required']) {
                                <span>{{'FIELD_REQUIRED' | translate}}</span>
                                }
                                @if (f['address'].errors['maxlength']) {
                                <span>{{'MAXLENGTH_200' | translate}}</span>
                                }
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['address'].value?.length || 0 }}/200</mat-hint>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-4 col-md-6 ps-0 form-field-wrapper">
                        <mat-checkbox formControlName="isAnonymous">
                            {{ 'KEEP_ME_ANONYMOUS' | translate }}
                            <span style="font-size:0.75rem; color:#9ca3af;">
                                {{ 'KEEP_ME_ANONYMOUS_DESC' | translate }}
                            </span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>

            <!-- <mat-card class="grid-card" id="page-content">
               
                <h2 class="dragCardsHeading">{{'CITIZEN_DETAILS' | translate}}</h2>

                <mat-grid-list class="bg-white" cols="3" rowHeight="80px">
                    <mat-grid-tile colspan="1">
                        <mat-form-field appearance="outline" class="form-field-title" style="width: 20%;">
                            <mat-label>{{'Title' | translate}}</mat-label>
                            <mat-select formControlName="complainantTitle" size="small">
                                @for (ct of complainantTitle;track ct) {
                                <mat-option [value]="ct">{{ct}}</mat-option>
                                }
                            </mat-select>
                            @if (f['complainantTitle'].errors) {
                            <mat-error>
                                @if (f['complainantTitle'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field class="ml-1" appearance="outline" style="width: 70%">
                            <mat-label>{{'NAME' | translate}} </mat-label>
                            <input matInput formControlName="complainantName" size="small">
                            @if (f['complainantName'].errors) {
                            <mat-error>
                                @if (f['complainantName'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['complainantName'].errors['maxLength']) { <span>{{'MAX_LENGTH_30' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="1">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'CNIC' | translate}} </mat-label>
                            <input matInput formControlName="cnic" size="small">
                            @if (f['cnic'].errors) {
                            <mat-error>
                                @if (f['cnic'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['cnic'].errors['pattern']) { <span>{{'CNIC_PATTERN' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                    <mat-grid-tile colspan="1">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'PHONE' | translate}} </mat-label>
                            <input matInput formControlName="cellPhoneNo" size="small" [maxLength]="11">
                            @if (f['cellPhoneNo'].errors) {
                            <mat-error>
                                @if (f['cellPhoneNo'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['cellPhoneNo'].errors['pattern']) { <span>{{'MAX_LENGTH_30' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </mat-grid-tile>
                </mat-grid-list>
                <mat-grid-list class="bg-white" cols="3" rowHeight="80px">
                        <mat-grid-tile colspan="1">
                            <mat-form-field appearance="outline">
                                <mat-label>{{'Passport no' | translate}} </mat-label>
                                <input matInput formControlName="passportNo" size="small">
                            </mat-form-field>

                        </mat-grid-tile>
                        <mat-grid-tile colspan="1">
                            <mat-form-field appearance="outline" floatLabel="always">
                                <mat-label>{{'ADDRESS' | translate}} </mat-label>
                                <textarea matInput formControlName="address" rows="3" style="resize: none;"></textarea>
                                @if (f['address'].errors) {
                                <mat-error>
                                    @if (f['address'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                        translate}}</span>}
                                </mat-error>
                                }
                            </mat-form-field>
                        </mat-grid-tile>
                </mat-grid-list>
            </mat-card> -->

            <div>
                <div class="row">
                    <div class="col-12 p-0" style="margin-top:5px; margin-bottom:5px">
                        <h2 class="dragCardsHeading">{{'Complaint Details' | translate}}</h2>
                    </div>
                </div>

                <div class="row g-3 complaint-details-container">
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'SEGMENT' | translate}}</mat-label>
                            <mat-select formControlName="segmentId">
                                <mat-option [value]="1">PULSE</mat-option>
                                <mat-option [value]="2">PLRA</mat-option>
                            </mat-select>
                            @if (f['segmentId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['segmentId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'PRIORITY' | translate}}</mat-label>
                            <mat-select formControlName="priority">
                                <mat-option [value]="'LOW'">Low</mat-option>
                                <mat-option [value]="'MEDIUM'">Medium</mat-option>
                                <mat-option [value]="'HIGH'">High</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'SEVERITY' | translate}}</mat-label>
                            <mat-select formControlName="severity">
                                <mat-option [value]="'EASY'">Easy</mat-option>
                                <mat-option [value]="'MEDIUM'">Medium</mat-option>
                                <mat-option [value]="'COMPLEX'">Complex</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'COMPLAINT_TYPE' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="complaintCategoryId"
                                (selectionChange)="clearSearch('category')">
                                <!-- Input field for searching -->
                                <input #searchComplaint id="search-select" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'COMPLAINT_TYPE' | translate }}"
                                    (keyup)="filterComplaintCategory($event)" />
                                @for (ct of categoryList;track ct) {
                                <mat-option [value]="ct.complaintCategoryId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['complaintCategoryId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['complaintCategoryId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'COMPLAINT_SUBTYPE' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="complaintSubcategoryId"
                                (selectionChange)="clearSearch('subCategory')">
                                <!-- Input field for searching -->
                                <input #searchSubCat id="search-select" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'COMPLAINT_SUBTYPE' | translate }}"
                                    (keyup)="filterSubCategory($event)" />
                                @for (ct of subCategoryList;track ct) {
                                <mat-option [value]="ct.complaintCategoryId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['complaintSubcategoryId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['complaintSubcategoryId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{'DAYS_REQUIRED' | translate}} </mat-label>
                            <input matInput formControlName="daysRequired">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{'LEGAL_FRAMEWORK' | translate}} </mat-label>
                            <input matInput formControlName="legalFramework">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{'EXPECTD_RESOLUTION_DATE' | translate}}: </mat-label>
                            <input matInput formControlName="expectedResolutionDate">
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'DIVISION' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="divisionId" size="small"
                                (selectionChange)="clearSearch('division')">
                                <input #searchDivision id="search-select" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'DIVISION' | translate }}"
                                    (keyup)="filterDivisions($event)" />
                                @for (ct of allDivisionList;track ct) {
                                <mat-option [value]="ct.adminStrId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['divisionId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['divisionId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'DISTRICT' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="districtId" size="small"
                                (selectionChange)="clearSearch('district')">
                                <!-- Input field for searching -->
                                <input #searchDistrict id="search-select" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'DISTRICT' | translate }}"
                                    (keyup)="filterDistricts($event)" />
                                @for (ct of districtList;track ct) {
                                <mat-option [value]="ct.adminStrId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['districtId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['districtId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'TEHSIL' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="tehsilId" size="small"
                                (selectionChange)="clearSearch('tehsil')">
                                <!-- Input field for searching -->
                                <input #searchTehsil id="search-select-tehsil" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'TEHSIL' | translate }}" (keyup)="filterTehsil($event)" />
                                @for (ct of tehsilList;track ct) {
                                <mat-option [value]="ct.adminStrId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['tehsilId'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['tehsilId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100">
                            <mat-label>{{'MOUZA' | translate}}</mat-label>
                            <mat-select class="ram" formControlName="mouzaId" size="small"
                                (selectionChange)="clearSearch('mouza')">
                                <!-- Input field for searching -->
                                <input #searchMouza id="search-select-mouza" class="w-100 border-0 p-1"
                                    placeholder="Search {{ 'MOUZA' | translate }}" (keyup)="filterMouza($event)" />
                                @for (ct of mouzaList;track ct) {
                                <mat-option [value]="ct.adminStrId">{{ct.name}}</mat-option>
                                }
                            </mat-select>
                            @if (f['mouzaId'].errors) {
                            <mat-error style="margin-top:5px">
                                <!-- @if (f['mouzaId'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                        translate}}</span>} -->
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100" floatLabel="always">
                            <mat-label>{{'COMPLAINT_ADDRESS' | translate}} </mat-label>
                            <textarea matInput formControlName="complaintAddress" rows="3" style="resize: none;"></textarea>
                            @if (f['complaintAddress'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['complaintAddress'].errors['required']) {
                                <span>{{'FIELD_REQUIRED' | translate}}</span>
                                }
                                @if (f['complaintAddress'].errors['maxlength']) {
                                <span>{{'MAXLENGTH_200' | translate}}</span>
                                }
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['complaintAddress'].value?.length || 0 }}/200</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0 complaint-field-wrapper">
                        <mat-form-field appearance="outline" class="bold-border w-100" floatLabel="always">
                            <mat-label>{{'OTHER_FORUM' | translate}} </mat-label>
                            <textarea matInput formControlName="otherForum" rows="3" style="resize: none;"></textarea>
                            @if (f['otherForum'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['otherForum'].errors['maxlength']) {
                                <span>{{'MAXLENGTH_200' | translate}}</span>
                                }
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['otherForum'].value?.length || 0 }}/200</mat-hint>
                        </mat-form-field>
                    </div>
                    <div class="col-12 p-0">
                        <h2 class="dragCardsHeading">{{'DESCRIPTION' | translate}}</h2>
                    </div>
                    <div class="col-lg-12 col-md-12 ps-0 textarea">
                        <!-- <mat-label>{{'DESCRIPTION' | translate}} </mat-label> -->
                        <div class="editor">
                            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                            <ngx-editor [editor]="editor" formControlName="complaintDetails" height="300px"
                                placeholder="{{'DESCRIPTION' | translate}}*"></ngx-editor>
                            <span class="editor-char-count">{{ descriptionLength }}/1500</span>
                        </div>
                        @if (f['complaintDetails'].errors && (f['complaintDetails'].dirty ||
                        f['complaintDetails'].touched)) {
                        <mat-error style="margin-top:5px">
                            @if (f['complaintDetails'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                translate}}</span>}
                            @if (f['complaintDetails'].errors['invalidDescription']) { <span>{{'FIELD_REQUIRED' |
                                translate}}</span>}
                            @if (f['complaintDetails'].errors['maxlength']) {<span>{{'MAX_LENGTH_1500' |
                                translate}}</span>}
                        </mat-error>
                        }
                    </div>
                </div>
            </div>

            <div>
                <div class="row">
                    <div class="col-12 p-0" style="margin-top:5px">
                        <h2 class="dragCardsHeading">{{'ADDITIONAL_DETAIL' | translate}}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 ps-0">
                        <mat-form-field appearance="outline" class="bold-border">
                            <mat-label>{{'Work Code' | translate}}</mat-label>
                            <mat-select formControlName="workCode" size="small">
                                @for (ct of workCodeList;track ct) {
                                <mat-option [value]="ct">{{ct}}</mat-option>
                                }
                            </mat-select>
                            @if (f['workCode'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['workCode'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-lg-4 col-md-6 ps-0">
                        <mat-form-field appearance="outline" class="bold-border">
                            <mat-label>{{'SOURCE' | translate}}</mat-label>
                            <mat-select formControlName="complaintSource" size="small" (change)="onSourceChange()">
                                @for (ct of sourceList;track ct) {
                                <mat-option [value]="ct">{{ct}}</mat-option>
                                }
                            </mat-select>
                            @if (f['complaintSource'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['complaintSource'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    @if(f['complaintSource']!.value === 'Other') {
                    <div class="col-lg-4 col-md-6 ps-0">
                        <mat-form-field appearance="outline" class="bold-border">
                            <mat-label>{{'OTHER_SOURCE' | translate}} </mat-label>
                            <input matInput formControlName="otherSource" maxlength="30" size="small">
                            @if (f['otherSource'].errors) {
                            <mat-error style="margin-top:5px">
                                @if (f['otherSource'].errors['maxlength']) {
                                <span>{{'MAXLENGTH_30' | translate}}</span>
                                }
                            </mat-error>
                            }
                            <mat-hint align="end">{{ f['otherSource'].value?.length || 0 }}/30</mat-hint>
                        </mat-form-field>
                    </div>
                    }

                    <!-- <mat-grid-tile colspan="1">
                        <mat-form-field appearance="outline">
                            <mat-label>{{'TIER' | translate}} </mat-label>
                            <input matInput formControlName="cellPhoneNo">
                            @if (f['tier'].errors) {
                            <mat-error>
                                @if (f['tier'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                                    translate}}</span>}
                                @if (f['tier'].errors['maxLength']) { <span>{{'MAX_LENGTH_30' |
                                    translate}}</span>}
                            </mat-error>
                            }
                        </mat-form-field>
                    </mat-grid-tile> -->

                </div>
                <div class="row">
                    <div class="col-md-10 ps-0" style="margin-top:5px">
                        <div colspan="2" class="identifierField">
                            <mat-label class="helpline-text">{{'HELPLINE_IDENTIFIER' | translate}}</mat-label>
                            <mat-radio-group formControlName="helplineIdentifier">
                                <mat-radio-button value="UAN">UAN</mat-radio-button>
                                <mat-radio-button value="ARC_Both_Call">ARC Booth Call</mat-radio-button>
                                <mat-radio-button value="CM_Complain_Cell">CM Complaint Cell</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 p-0">
                        <h2 class="dragCardsHeading">{{'ADD_ATTACHMENTS_TITLE' | translate }}</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 ps-0">
                        <td mat-cell *matCellDef="let row; let i = index"></td>
                        <!-- @if ([].includes() {
                            
                            }  -->
                        @for (d of documentList;track d; let index = $index) {
                        <div class="row">
                            <div class="col-lg-3 col-md-4 col-12 align-self-center">
                                <button mat-raised-button color="primary" (click)="download(d?.complaintDocumentId)"
                                    style="
                                    margin-right: 20px;
                                    margin-top: 10px;
                                    max-width: 350px !important;
                                    white-space: pre-line;
                                    word-wrap: break-word;
                                    height: 30px;
                                  ">
                                    <span title="{{d?.documentName}}"> {{truncateText( d?.documentName,13)}}
                                    </span></button>
                            </div>
                            <div class="col-lg-2 col-md-3 col-11 align-self-center">
                                <mat-checkbox [(ngModel)]="d.isPublished"
                                    [ngModelOptions]="{standalone: true}">{{'PUBLISHED' | translate}}</mat-checkbox>
                            </div>
                            <div class="col-lg-3 col-md-4 col-1 align-self-center">
                                <mat-icon (click)="removeDocument(index)">cancel</mat-icon>
                            </div>
                        </div>
                        }
                        <input style="margin-top:10px" type='file' class="text-end btn-primary"
                            (change)="onSelectFile($event)" multiple>
                        @if (fileError) {
                        <mat-error style="margin-top:5px">
                            <span style="color:red">{{'FILE_ATTACHMENT_ERROR' | translate}}</span>
                        </mat-error>
                        }
                    </div>
                </div>

                <mat-card-actions align="end">
                    <button mat-button class="btn-secondary" (click)="cancel()">{{'Cancel' | translate}}</button>

                    @if (f['complaintId'].value != null) {
                    <button mat-raised-button type="submit" class="ml-1" color="primary" [disabled]="form.invalid"
                        (click)="edit()">{{'Edit Complaint' | translate}}
                    </button>
                    } @else {
                    <button mat-raised-button type="submit" class="ml-1" color="primary" [disabled]="form.invalid"
                        (click)="add()">{{'Add Complaint' | translate}} </button>
                    }
                </mat-card-actions>
            </div>

        </mat-card-content>
    </mat-card>

</form>